import { withCompInfo } from '../../core/withCompInfo'
import { PaginationDefinition, PaginationFormProps, PaginationStripProps, PaginationMode } from './types'

export const props = withCompInfo<PaginationStripProps | PaginationFormProps, PaginationDefinition>(
	['compData', 'compProps'],
	({ compData, compProps }) => {
		const { totalPages, currentPage, nextText, previousText, firstText, lastText } = compData
		const {
			showFirstLastNavButtons,
			showFirstPage,
			showLastPage,
			showInputModeTotalPages,
			navigationType,
			paginationDirection,
			paginationMode,
			isDisabled,
		} = compProps
		const paginationProps = {
			totalPages,
			currentPage,
			nextText,
			previousText,
			firstText,
			lastText,
			showFirstLastNavButtons,
			navigationType,
			paginationDirection,
			isDisabled,
		}
		const propsMapper: {
			[key in PaginationMode]: PaginationFormProps | PaginationStripProps
		} = {
			input: { ...paginationProps, showTotalPages: showInputModeTotalPages },
			pages: { ...paginationProps, showFirstLastPageButtons: showFirstPage || showLastPage },
		}
		return propsMapper[paginationMode]
	}
)
